import { createUseStyles } from "react-jss";

export const useStyleSVG = createUseStyles({
  svg: {
    width: "24px",
  },
});

export type SvgProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};
